export default __webpack_public_path__ + "static/media/signupImg.a98850fb.png";